import { useSelector } from 'react-redux';
import { Convert, Units } from '@topconagriculture/unit-of-measure';
import { getUnitFormatLabel } from '@topconagriculture/unit-of-measure/dist/format';
import { getRegionalSettingsName } from '@topconagriculture/profiling/build/store/profiling.selector';
import { RegionalSettingNames } from '@topconagriculture/frontend-utils';
import { convertUnitByMeasureSystem } from '../../../utils/utils';
export const useWeatherSelector = (weather) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const regionalSettings = useSelector(getRegionalSettingsName) || RegionalSettingNames.INTERNATIONAL;
    const system = regionalSettings;
    if (!weather)
        return undefined;
    const weatherInfo = {
        date: (_a = weather === null || weather === void 0 ? void 0 : weather.date) !== null && _a !== void 0 ? _a : new Date().toISOString(),
        description: (_b = weather === null || weather === void 0 ? void 0 : weather.description) !== null && _b !== void 0 ? _b : '-',
        weatherCode: (_c = weather === null || weather === void 0 ? void 0 : weather.weatherCode) !== null && _c !== void 0 ? _c : '-',
        precipitationProbability: (_d = weather === null || weather === void 0 ? void 0 : weather.precipitationProbability) !== null && _d !== void 0 ? _d : '-',
        maxTemperature: (_e = weather === null || weather === void 0 ? void 0 : weather.maxTemperature) !== null && _e !== void 0 ? _e : '-',
        minTemperature: (_f = weather === null || weather === void 0 ? void 0 : weather.minTemperature) !== null && _f !== void 0 ? _f : '-',
        currentTemperature: (_g = weather === null || weather === void 0 ? void 0 : weather.currentTemperature) !== null && _g !== void 0 ? _g : '-',
        avgWindSpeed: (_h = weather === null || weather === void 0 ? void 0 : weather.avgWindSpeed) !== null && _h !== void 0 ? _h : '-',
        temperatureUOMLabel: getUnitFormatLabel(Units.Celsius),
        windSpeedUOMLabel: getUnitFormatLabel(Units.KilometerPerHour),
    };
    if (system !== Convert.UnitOfMeasureSystem.INTERNATIONAL) {
        Object.assign(weatherInfo, {
            ...weatherInfo,
            maxTemperature: weatherInfo.maxTemperature !== '-'
                ? Math.round(convertUnitByMeasureSystem(Units.Celsius, +weatherInfo.maxTemperature, system).value)
                : '-',
            minTemperature: weatherInfo.maxTemperature !== '-'
                ? Math.round(convertUnitByMeasureSystem(Units.Celsius, +weatherInfo.minTemperature, system).value)
                : '-',
            currentTemperature: weatherInfo.maxTemperature !== '-'
                ? Math.round(convertUnitByMeasureSystem(Units.Celsius, +weatherInfo.currentTemperature, system).value)
                : '-',
            avgWindSpeed: weatherInfo.avgWindSpeed !== '-'
                ? Math.round(convertUnitByMeasureSystem(Units.KilometerPerHour, +weatherInfo.avgWindSpeed, system).value)
                : '-',
            temperatureUOMLabel: weatherInfo.currentTemperature !== '-'
                ? convertUnitByMeasureSystem(Units.Celsius, +weatherInfo.currentTemperature, system).unitLabel
                : getUnitFormatLabel(Units.Fahrenheit),
            windSpeedUOMLabel: weatherInfo.avgWindSpeed !== '-'
                ? convertUnitByMeasureSystem(Units.KilometerPerHour, +weatherInfo.avgWindSpeed, system).unitLabel
                : '',
        });
    }
    return weatherInfo;
};
//# sourceMappingURL=useWeatherSelector.js.map